import { Action } from 'redux';

// import * as _moment from 'moment';
import type { Moment } from 'moment';
// const moment = _moment;
import moment from 'moment';
import 'moment-timezone';
import { MomentTimeZoneEnum } from 'src/app/shared/enums/moment-timezone.enum';
import { environment } from 'src/environments/environment';

/** @TODO - generate based on Environment File. */
const currentTimeZone = MomentTimeZoneEnum[environment.configs.siteTimeZone];

export interface NowStateStructure {
  now: string;
}


/** INITIAL STATE */
const INITIAL_STATE: NowStateStructure = {
  now: 'now',  // TODO: Make a more permanent solution. getFirstOfNextMonth().format('YYYY-MM-DD'), //startOfNextMonth.format('YYYY-MM-DD'),
};

/** ACTION TYPES */
const SET_NOW = 'SET_NOW';

/** ACTION INTERFACE */
export class NowAction implements Action {
  type: string;
  now: string;
}

/** EFFECTIVE DATE ACTIONS */
export function setNow(now: string) { return { type: SET_NOW, now }; }

/** REDUCER */
export function Now(state: NowStateStructure = INITIAL_STATE, action: NowAction) {

  const copiedState: NowStateStructure = JSON.parse(JSON.stringify(Object.assign({}, state)));

  switch (action.type) {
    case SET_NOW:
      copiedState.now = action.now;
      return Object.assign({}, state, copiedState);
    default:
      return state;
  }
}
